<template>
	<div class="featured-products">
		<div class="featured-products-title">
			<b>{{ title }}</b>
			<!-- <span class="featured-products-product" v-if="products[0]">{{ products[0].name }}</span> -->
		</div>
		<div class="featured-products-list">
			<div class="list-empty" v-if="!products || products.length === 0">
				<i class="material-icons md-48">error_outline</i> No {{ title.toLowerCase() }} yet.
			</div>
			<featured-product
				v-for="product in products"
				:key="product._id.$oid"
				:id="product._id.$oid"
				:name="product.name"
				:image="product.picture"
				:submission="product.submission_count"
				:transaction="product.transaction_count"
				:paidRatio="product.paid_ratio"
				:revenue="product.net_revenue"
				:highlight="highlight"
			></featured-product>
		</div>
	</div>
</template>

<script>
import FeaturedProduct from './FeaturedProduct.vue';

export default {
	name: 'FeaturedProducts',
	props: ['title', 'products', 'highlight'],
	components: {
		FeaturedProduct,
	},
};
</script>

<style lang="scss">
@import '../assets/scss/modules/_variables.scss';

// .featured-products {
// }

.featured-products-title {
	margin-bottom: 1rem;
	text-align: left;
	font-size: 1.2em;
	font-weight: bold;
}

.featured-products-product {
	color: $color__primary;
	font-size: 1em;
	font-weight: bold;
}
</style>
